import http from '../../http/requests/quality-assurance';
import PAxios from '../../http/requests/projects';
import OAxios from '../../http/requests/orders';

export default {
    openModal ({
        commit,
        dispatch,
    }, payload) {
        commit('TOGGLE_EDIT_MODAL', {
            open: true,
            id: payload.id,
        });

        if (payload.hasOwnProperty('fromQr') && payload.fromQr) {
            dispatch('openQrScanner');
        }
    },
    closeModal ({ commit }) {
        commit('TOGGLE_EDIT_MODAL', {
            open: false,
            id: null,
        });

        commit('TOGGLE_ACTION_WITH_REASON', {
            open: false,
        })
    },
    createUpdate ({ commit }, payload) {
        let data = JSON.parse(JSON.stringify(payload));
        return new Promise((resolve, reject) => {
            http.createUpdate(data)
                .then(response => {
                    commit('SET_EDIT_MODAL_ERRORS', {});
                    commit('SET_EDIT_MODAL_DATA', response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        commit('SET_EDIT_MODAL_ERRORS', error.response.data.data);
                    }

                    reject(error);
                });
        });
    },
    setData ({ commit }, data) {
        commit('SET_EDIT_MODAL_DATA', data);
    },
    getCreationInformation ({ commit }) {
        return new Promise((resolve, reject) => {
            http.getCreationInformation()
                .then(response => {
                    if (!response.data.success) {
                        reject({ message: response.data.message });
                    }

                    commit('SET_CREATION_INFO', response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    getList (_, payload) {
        return http.getList(payload.httpOptions);
    },
    get ({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get(id)
                .then(response => {
                    if (!response.data.success) {
                        reject({ message: response.data.message });
                    }

                    commit('SET_EDIT_MODAL_DATA', response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    toggleListRefresh ({ commit }, status) {
        commit('TOGGLE_LIST_REFRESH', status);
    },
    getUploadUrl (_, payload) {
        return new Promise((resolve, reject) => {
            http.getFileUploadUrl(payload.fileName).then(response => {
                if (!response.data.success) {
                    reject({ message: response.data.message });
                }

                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getOpenPdfUrl (_, id) {
        return new Promise((resolve, reject) => {
            http.getOpenPdfUrl(id)
                .then(response => {
                    if (!response.data.success) {
                        reject({ message: response.data.message });
                    }
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    getFiltersInformation ({ commit }) {
        return new Promise((resolve, reject) => {
            http.getFiltersInformation()
                .then(response => {
                    if (!response.data.success) {
                        reject({ message: response.data.message });
                    }

                    commit('SET_FILTERS_INFO', response.data.data);

                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    setListFilters ({
        commit,
        state,
        dispatch,
    }, data) {
        commit('SET_FILTERS_DATA', data);

        dispatch('storeQualityAssuranceListFilters', state.qualityAssuranceList.filters);
    },
    toggleListFiltersSidebar ({ commit }, status) {
        commit('TOGGLE_FILTER_SIDEBAR', status);
    },
    removeListFilter ({
        commit,
        state,
        dispatch,
    }, data) {
        commit('REMOVE_FILTER', data);

        dispatch('storeQualityAssuranceListFilters', state.qualityAssuranceList.filters);
    },
    storeQualityAssuranceListFilters (_, payload) {
        localStorage.setItem('qualityAssuranceListFilters', JSON.stringify(payload));
    },
    restoreListFilters ({ commit }) {
        let filters = localStorage.getItem('qualityAssuranceListFilters');
        if (filters === null) {
            return;
        }

        commit('SET_FILTERS_DATA', JSON.parse(filters));
    },
    toggleConfirmationModal ({ commit }, data) {
        commit('TOGGLE_CONFIRMATION_MODAL', data);
    },
    addFile ({ commit }, data) {
        commit('ADD_FILE', data);
    },
    removeFile ({ commit }, data) {
        commit('REMOVE_FILE', data);
    },
    removeOldPositionImages ({ commit }, data) {
        commit('REMOVE_OLD_POSITION_IMAGES', data.fileNamesToExclude);
    },
    cancel ({ commit }, payload) {
        return new Promise((resolve, reject) => {
            http.cancel(payload.id, payload.reason)
                .then(response => {
                    commit('SET_EDIT_MODAL_DATA', response.data.data);

                    resolve(response);
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        commit('SET_ACTION_ERRORS', error.response.data.data);
                    }

                    reject(error);
                });
        });
    },
    complete ({ commit }, payload) {
        return new Promise((resolve, reject) => {
            http.complete(payload.id)
                .then(response => {
                    commit('SET_EDIT_MODAL_DATA', response.data.data);

                    resolve(response);
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        commit('SET_ACTION_ERRORS', error.response.data.data);
                    }

                    reject(error);
                });
        });
    },
    toggleActionWithReasonBlock ({ commit }, data) {
        commit('TOGGLE_ACTION_WITH_REASON', data);
    },
    setActionReason ({ commit }, data) {
        commit('SET_ACTION_REASON', data);
    },
    setProjectsAutocompleteSearchTerm ({ commit }, term) {
        commit('SET_PROJECTS_SEARCH_TERM', term);
    },
    setOrdersAutocompleteSearchTerm ({ commit }, term) {
        commit('SET_ORDERS_SEARCH_TERM', term);
    },
    getAutocompleteProjectsBySearchTerm ({
        commit,
        state,
    }, searchTerm) {
        return new Promise((resolve, reject) => {
            PAxios.getAutocompleteProjectsBySearchTerm(searchTerm)
                .then(response => {
                    if (!response.data.success) {
                        reject({ message: response.data.message });
                    }

                    if (state.qualityAssuranceModal.autocomplete.projectsSearchTerm === searchTerm) {
                        commit('SET_EDIT_MODAL_PROJECTS', response.data.data);
                    }

                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    getAutocompleteOrdersBySearchTerm ({
        commit,
        state,
    }, payload) {
        return new Promise((resolve, reject) => {
            OAxios.getAutocompleteOrdersBySearchTerm(payload.projectId, payload.term)
                .then(response => {
                    if (!response.data.success) {
                        reject({ message: response.data.message });
                    }

                    if (state.qualityAssuranceModal.autocomplete.ordersSearchTerm === payload.term) {
                        commit('SET_EDIT_MODAL_ORDERS', response.data.data);
                    }

                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    openQrScanner({commit}) {
        commit('TOGGLE_QR_READER', true)
    },
    closeQrReader({commit}) {
        commit('TOGGLE_QR_READER', false)
    },
    getDetailsByQrCode(_, payload) {
        return new Promise((resolve, reject) => {
            http.getDetailsByQrCode(payload.qrCode)
                .then(response => {
                    if (!response.data.success) {
                        reject({ message: response.data.message });
                    }
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
};
